import React, { memo } from 'react';
export const PromiseSection = memo(function PromiseSection() {
  return;
});